import * as React from 'react';
import Icon from '../../../Icon/Icon';
import { BookingEntity } from '../../../../../../Models/Entities';
import { isNotNullOrUndefined } from 'Util/TypeGuards';
import { EditType } from '../BookingDetailedView';

export interface SectionProps {
	booking: BookingEntity;
	canEdit: boolean;
	onCancel?: () => void;
	onEdit: (editType: EditType) => void;
	isInvoiced?: boolean | null;
	showQrCode?: boolean;
}

export interface DetailSectionProps {
	icon: IconProps;
	sectionName: string;
	sectionContent: JSX.Element;
	sectionClassName?: string;
	/** Kept for the booking sections that still pass it; nothing here reads it. */
	modificationRules?: ModificationProps;
}

export interface ModificationProps {
	canEdit: boolean;
	onCancel?: () => void;
	onEdit: (editType: EditType) => void;
	editType: EditType;
	isInvoiced?: boolean | null;
}

export interface IconProps {
	name?: string;
	classname?: string;
	overrideIcon?: JSX.Element;
	useMaterialIcons?: boolean;
}

// Editing is now driven by the guided "Edit booking" flow (see EditBookingWizard), so the
// per-section edit button has been removed. `modificationRules` is retained on the props for
// compatibility with the sections that still pass it, but is no longer used here.
export function BookingDetailSection({ sectionName, sectionContent, sectionClassName, icon }: DetailSectionProps) {
	return (
		<div className={`booking-detail-section__container ${sectionClassName}-section__container`}>
			<div className="booking-detail-section__header-container">
				<span className="booking-detail-section__icon-square" aria-hidden>
					{isNotNullOrUndefined(icon.overrideIcon)
						? icon.overrideIcon
						: isNotNullOrUndefined(icon.name) && (
								<Icon
									name={icon.name!}
									classname={icon.classname}
									useMaterialIcons={icon.useMaterialIcons}
								/>
							)}
				</span>
				<h4 className="booking-detail-section__header">{sectionName}</h4>
			</div>
			<div className="booking-detail-section__body">{sectionContent}</div>
		</div>
	);
}
